/** @jsx jsx */
import { jsx, Box } from 'theme-ui';
import React, { FunctionComponent } from 'react';

// Styles
import { baseStyle } from './style';

const TripleCardList: FunctionComponent = React.memo(({ children }) => (
  <Box as="section" sx={baseStyle.mainContainer}>
    {children}
  </Box>
));

export default TripleCardList;
